<template>
  <b-container active @click="tabClick(2017)" :id="`electric-${year}`">
    <div id="control-header" style="padding: 10px; font-size: large; font-weight: bold">
      <b-row>
        <b-col cols="9">
          Electricity Data <p/><span
            style="font-size: medium; font-weight: normal">*Note: PG&E does not track your solar energy use, this must be requested from your solar vendor</span>
        </b-col>
        <b-col cols="3" class="text-right">
          <b-button size="sm" @click="requestDownload()">
            Export Electricity Data
          </b-button>
        </b-col>
      </b-row>
    </div>
    <ag-grid-vue style="width: 100%; height: 400px"
                 class="ag-theme-balham"
                 :gridOptions="topGridOptions"
                 :columnDefs="columnDefs"
                 :rowData="rowData"
                 :defaultColDef="defaultColDef"
                 :enterMovesDownAfterEdit="true"
                 @grid-ready="onGridReady"
                 @cell-clicked="onCellClicked"
                 @cell-editing-stopped="onCellEditingStopped">
    </ag-grid-vue>
    <ag-grid-vue style="width: 100%; height: 40px;"
                 class="ag-theme-balham"
                 :gridOptions="bottomGridOptions"
                 :headerHeight="0"
                 :columnDefs="bottomColumnDefs"
                 :rowData="bottomDataCalc"
                 :rowStyle="rowStyle"
    ></ag-grid-vue>

  </b-container>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import Bus from "../eventBus";
import {roundColumnValue} from "@/MetricUtils";
import {FileUtils} from "@/lib/FileUtils";

var SizeEnum = {
  SP: 'solarProductivity',
  EM1: 'electricMeter',
  EM2: 'electricMeter2',
  EM3: 'electricMeter3'
};

window.numberParser = function numberParser(params) {
  let parsedNumber = Number(params.newValue);
  return isNaN(parsedNumber) ? "ERROR" : parsedNumber;
};

export default {
  name: "MetricTable",
  props: {rows: Array, year: String, id: String, groupId: String},
  components: {
    AgGridVue
  },

  data() {
    return {
      metricYearVal: this.year,
      gridApi: null,
      gridColumnApi: null,
      columnDefs: null,
      bottomColumnDefs: null,
      defaultColDef: null,
      pinnedTopRowData: null,
      pinnedBottomRowData: null,
      topGridOptions: null,
      bottomGridOptions: null,
      rowData: this.rows,
      bottomData: [],
      rowStyle: {fontWeight: 'bold'},
      metricId: this.id,
      myGroupId: this.groupId,
      isViewer: localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('VIEWER')
    }
  },
  created() {
    Bus.$on('update-requests', this.sendMetricsUpdate);

  },
  beforeDestroy() {
    Bus.$off('update-requests', this.sendMetricsUpdate);
  },
  mounted() {
    this.gridApi = this.topGridOptions.api;
    this.gridColumnApi = this.topGridOptions.columnApi;
    //this.gridApi.setRowData(this.rowData);
    this.$nextTick(this.sendMetricsUpdate(this.metricYearVal))
  },
  beforeMount() {

    this.columnDefs = [
      {
        headerName: 'Month', field: 'month', pinned: "left",
        lockPinned: true,
        width: 100,
        editable: false
      },
      {
        headerName: 'Year', field: 'year', pinned: "left",
        lockPinned: true,
        width: 75,
        editable: false
      },
      {
        headerName: 'Solar Production(kWh) Winery',
        field: 'solarProductivity',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 2)
      },
      {
        headerName: 'Electric Meter 1(kWh) Winery',
        field: 'electricMeter',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 2)
      },
      {
        headerName: 'Electric Meter 2(kWh) Tasting/Offices',
        field: 'electricMeter2',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 2)
      },
      {
        headerName: 'Electric Meter 3(kWh) Wastewater Ponds',
        field: 'electricMeter3',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 2)
      },
    ];
    this.bottomColumnDefs = [
      {
        headerName: 'Month', field: 'month', pinned: "left",
        lockPinned: true,
        width: 100,
        editable: false
      },
      {
        headerName: 'Year', field: 'year', pinned: "left",
        lockPinned: true,
        width: 75,
        editable: false
      },
      {
        headerName: 'Solar Production(kWh) Winery',
        field: 'solarProductivity',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 0)
      },
      {
        headerName: 'Electric Meter 1(kWh) Winery',
        field: 'electricMeter',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 0)
      },
      {
        headerName: 'Electric Meter 2(kWh) Tasting/Offices',
        field: 'electricMeter2',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 0)
      },
      {
        headerName: 'Electric Meter 3(kWh) Wastewater Ponds',
        field: 'electricMeter3',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], 0)
      },
    ];
    this.bottomData = [
      {
        month: 'Total',
        year: '******',
        solarProductivity: 'a lot',
        electricMeter: 'not as much',
        electricMeter2: 'a little more',
        electricMeter3: '=ctx.sum("solarProductivity")'
      }
    ];


    this.defaultColDef = {
      editable: true,
      resizable: true
    };

    this.pinnedTopRowData = getPinnedTopData();
    this.pinnedBottomRowData = getPinnedBottomData();

    this.topGridOptions = {alignedGrids: [], suppressHorizontalScroll: true};
    this.bottomGridOptions = {
      alignedGrids: [], enableCellExpressions: true, context: {
        theNumber: 4
      }
    };
    this.topGridOptions.alignedGrids.push(this.bottomGridOptions);
    this.bottomGridOptions.alignedGrids.push(this.topGridOptions);

    //this.gridApi.setRowData(this.rowData);

    let totalSolar = 0;
    let totalElec = 0;
    let totalElec2 = 0;
    let totalElec3 = 0;
    if (self.gridApi !== undefined) {
      self.gridApi.forEachNode(function (node) {
        if (node.data["year"] === event.data["year"]) {
          //total += parseInt(node.data[event.colDef.field], 10);
          totalSolar += Number(node.data["solarProductivity"]) || 0;
          totalElec += Number(node.data["electricMeter"]) || 0;
          totalElec2 += Number(node.data["electricMeter2"]) || 0;
          totalElec3 += Number(node.data["electricMeter3"]) || 0;
        }
      });
    }
    //this.calculateAndEmitTotals(totalSolar, totalElec, totalElec2, totalElec3, "beforeMount", event);

  },
  watch: {
    rows: function (newVal) {
      this.rowData = newVal;
      this.$nextTick(() => {
        console.log("Metric Year Value", this.metricYearVal);
        this.sendMetricsUpdate(this.metricYearVal);
      });
    }
  },
  computed: {
    bottomDataCalc: function () {

      let self = this;
      let bottomRowsMap = new Map();
      let columnNames = [];
      Object.values(SizeEnum).map(key => {
        let result = 0;
        Object.values(self.rowData).forEach(row => {

          result += row[key];

        });
        columnNames.push(result);
      });

      let bottom =
          {
            month: "Total",
            year: '******',
            solarProductivity: 0,
            electricMeter: 0,
            electricMeter2: 0,
            electricMeter3: 0
          };
      if (bottomRowsMap !== undefined) {
        bottom = {
          month: "Total",
          year: '******',
          solarProductivity: Number(columnNames[0]),
          electricMeter: Number(columnNames[1]),
          electricMeter2: Number(columnNames[2]),
          electricMeter3: Number(columnNames[3])
        };
      }
      return [bottom];
    }

  },
  methods: {
    bottomDataCalcFunc: function (year) {
      let bottom =
          {
            month: "Total",
            year: '******',
            solarProductivity: 0,
            electricMeter: 0,
            electricMeter2: 0,
            electricMeter3: 0
          };
      return [bottom];
    },
    tabClick: function () {
    },
    onBtStopEditing() {
      this.gridApi.stopEditing();

    },
    cellValueChanged() {
      this.bottomGridOptions.api.refreshView();
    },
    onBtStartEditing(key, char, pinned) {
      this.gridApi.setFocusedCell(0, "month", pinned);
      this.gridApi.startEditingCell({
        rowIndex: 0,
        colKey: "month",
        rowPinned: pinned,
        keyPress: key,
        charPress: char
      });
    },
    onBtNextCell() {
      this.gridApi.tabToNextCell();
    },
    requestDownload() {
      let self = this;
      this.$http.get(`metrics/download/${self.myGroupId}/${self.metricYearVal}/power/wine`, {responseType: "blob"})
          .then(async response => {
            FileUtils.saveExcelToDisk(response);
          });
    },
    onBtPreviousCell() {
      this.gridApi.tabToPreviousCell();
    },
    onBtWhich() {
      let cellDefs = this.gridApi.getEditingCells();
      if (cellDefs.length > 0) {
        var cellDef = cellDefs[0];
        console.log(
            "editing cell is: row = " +
            cellDef.rowIndex +
            ", col = " +
            cellDef.column.getId() +
            ", floating = " +
            cellDef.floating
        );
      } else {
        console.log("no cells are editing");
      }
    },
    onGridReady(params) {

      this.gridApi = this.topGridOptions.api;
      this.gridColumnApi = this.topGridOptions.columnApi;
      const updateData = data => {
        this.rowData = data;
      };
    },
    onCellClicked(event) {
      //console.log('onCellClicked: ' + event.rowIndex + ' ' + event.colDef.field);

    },
    calculateAndEmitTotals: function (totalSolar, totalElec, totalElec2, totalElec3, when, event) {
      this.bottomGridOptions.api.getRowNode('0').data["solarProductivity"] = totalSolar;
      this.bottomGridOptions.api.getRowNode('0').data["electricMeter"] = totalElec;
      this.bottomGridOptions.api.getRowNode('0').data["electricMeter2"] = totalElec2;
      this.bottomGridOptions.api.getRowNode('0').data["electricMeter3"] = totalElec3;

      let powerEmission = {
        gridType: "powerEmission",
        totalSolar: totalSolar,
        totalGrid: totalElec + totalElec2 + totalElec3,
        year: this.metricYearVal, //event.data["year"],
        when: when
      };
      Bus.$emit('grid-edited', powerEmission);
    },
    sendMetricsUpdate(year) {
      let self = this;
      let totalSolar = 0;
      let totalElec = 0;
      let totalElec2 = 0;
      let totalElec3 = 0;

      if (this.gridApi !== undefined) {
        console.log("Traverse GridApi");
        this.gridApi.forEachNode(function (node) {
          if (node.data["year"] === year || node.data["year"] === year.toString()) {
            //total += parseInt(node.data[event.colDef.field], 10);
            totalSolar += self.safeParseNumber(node, "solarProductivity");
            totalElec += self.safeParseNumber(node, "electricMeter");
            totalElec2 += self.safeParseNumber(node, "electricMeter2");
            totalElec3 += self.safeParseNumber(node, "electricMeter3");
          }
        });
      }
      this.calculateAndEmitTotals(totalSolar, totalElec, totalElec2, totalElec3, "gridReady", event);
    },
    safeParseNumber: function (node, indexName, updateCell = false) {
      let isNotANumber = isNaN(node.data[indexName]);
      //console.log(`Is Not a Number: ${isNotANumber}, Node Value: ${node.data[indexName]} returned Value: ${isNotANumber ? 0 : node.data[indexName]}`);
      return isNotANumber ? 0 : node.data[indexName];
    },
    updatePowerMetrics: function (self) {
      if (self.gridApi !== undefined) {
        let year = {};
        let powerMetricsMonth = [];
        self.gridApi.forEachNode(function (node) {
          year = node.data["year"];
          powerMetricsMonth.push({
            month: node.data["month"],
            solarProductivity: self.safeParseNumber(node, "solarProductivity"),
            electricMeter: self.safeParseNumber(node, "electricMeter"),
            electricMeter2: self.safeParseNumber(node, "electricMeter2"),
            electricMeter3: self.safeParseNumber(node, "electricMeter3"),
          })
        });
        let metricYear = {
          _id: this.id,
          year: year,
          groupId: this.myGroupId,
          months: powerMetricsMonth
        };
        console.log("Metrics Year");
        console.log(JSON.stringify(metricYear));
        this.$http.put("/metrics/power/" + this.metricId, JSON.stringify(metricYear), {
          headers: {
            'content-type': 'application/json'
          }
        }).then(response => {
          console.log(response);
          // TODO Add Notification for Updated Metrics
          if (self.id == null) {
            self.id = response.data;
            self.metricId = self.id;
          }
        }).catch(error => {
          console.log("Error Putting Data");
          console.error(error);
        })
      }
    },
    onCellEditingStopped(event) {
      let self = this;
      let totalSolar = 0;
      let totalElec = 0;
      let totalElec2 = 0;
      let totalElec3 = 0;
      if (self.gridApi !== undefined) {
        self.gridApi.forEachNode(function (node) {
          if (node.data["year"] === event.data["year"]) {
            totalSolar += self.safeParseNumber(node, "solarProductivity");
            totalElec += self.safeParseNumber(node, "electricMeter");
            totalElec2 += self.safeParseNumber(node, "electricMeter2");
            totalElec3 += self.safeParseNumber(node, "electricMeter3");
          }
        });
      }

      this.updatePowerMetrics(self);

      this.calculateAndEmitTotals(totalSolar, totalElec, totalElec2, totalElec3, "cellStoppedEditing", event);
      this.bottomGridOptions.api.redrawRows({rowNodes: [this.bottomGridOptions.api.getRowNode('0')]})
    }
  }
}

function getPinnedTopData() {
  return [
    {
      firstName: "##",
      lastName: "##",
      gender: "##",
      address: "##",
      mood: "##",
      country: "##"
    }
  ];
}

function getPinnedBottomData() {
  return [
    {
      firstName: "##",
      lastName: "##",
      gender: "##",
      address: "##",
      mood: "##",
      country: "##"
    }
  ];
}

function getCharCodeFromEvent(event) {
  event = event || window.event;
  return typeof event.which === "undefined" ? event.keyCode : event.which;
}

function isCharNumeric(charStr) {
  return !!/\d/.test(charStr);
}

function isKeyPressedNumeric(event) {
  var charCode = getCharCodeFromEvent(event);
  var charStr = String.fromCharCode(charCode);
  return isCharNumeric(charStr);
}
</script>

<style scoped>

</style>
